import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import "./outputTable.scss";
import {
  Box,
  Checkbox,
  Dialog,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { action } from "../../constants/action";
import ExcelOutput from "../../pages/administrator/ExcelOutPut";
// import { useSelector } from "react-redux";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TaskAltTwoToneIcon from "@mui/icons-material/TaskAltTwoTone";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { adminRoutes } from "../../routes/routeConstants";

const Tables = (props) => {
  const {
    data,
    handleRefresh,
    selectedRows = [],
    setSelectedRows = null,
  } = props;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [data1, setData1] = useState("");
  const [preview, setPreview] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setdialogData] = useState({});
  // const [message, setMessage] = useState("");
  // const [success, setSuccess] = useState(false);
  // const apiStatus = useSelector((state) => state?.admin?.apiStatus);

  const handleClick = (event, list) => {
    setPreview(list);
    setAnchorEl(event.currentTarget);
    setData1(list?.id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setdialogData({});
    handleRefresh();
  };
  const showPreviewDetails = () => {
    setOpenDialog(true);
    setdialogData(preview);
    setAnchorEl(null);
  };

  const PreviewDataPointCalculation = () => {
    // navigate("/data-point-calculation", {
    //   state: { id: data1 },
    // });
    navigate(`/${adminRoutes.dataPointCalculation}`, {
      state: { id: data1 },
    });
  };

  const handleCheckboxChange = (id) => {
    if (!setSelectedRows) return;

    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(data.map((item) => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  const allSelected = data?.length > 0 && selectedRows?.length === data?.length;

  return (
    <Box className="outputTable-container ">
      <Box className="dashboard-wrap-table">
        <TableContainer className="table-container h-100">
          <Table
            stickyHeader
            className="table-output"
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" align="center">
                  <Checkbox
                    indeterminate={
                      selectedRows?.length > 0 &&
                      selectedRows?.length < data?.length
                    }
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />
                </TableCell>

                <TableCell align="center" className="index-cell">
                  Index
                </TableCell>

                <TableCell align="left">Project Name</TableCell>

                <TableCell align="left">Batch Name</TableCell>
                <TableCell align="left">File Name</TableCell>

                <TableCell align="left">Status</TableCell>

                <TableCell align="left">Created Date</TableCell>

                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((list, index) => {
                return (
                  <>
                    <TableRow key={list.id} className="row-wrap">
                      <TableCell padding="checkbox" align="center">
                        <Checkbox
                          checked={
                            list.submitted_to_srm ||
                            selectedRows.includes(list.id)
                          }
                          onChange={() => handleCheckboxChange(list.id)}
                          disabled={list.submitted_to_srm === true}
                        />
                      </TableCell>

                      <TableCell align="center"> {index + 1}</TableCell>

                      <TableCell align="left">{list.project_name}</TableCell>

                      <TableCell align="left">{list.batch_name}</TableCell>

                      <TableCell align="left">{list.file_name}</TableCell>

                      {list.rejected === true ? (
                        <TableCell>
                          <Tooltip arrow title="Rejected">
                            <HighlightOffRoundedIcon color="error" />
                          </Tooltip>
                        </TableCell>
                      ) : (
                        <TableCell align="left">
                          {list.status ? (
                            <Tooltip arrow title="Approved">
                              <TaskAltTwoToneIcon color="success" />
                            </Tooltip>
                          ) : (
                            <Tooltip arrow title="Pending">
                              <HourglassEmptyIcon color="action" />
                            </Tooltip>
                          )}
                        </TableCell>
                      )}

                      <TableCell>{list.created_date}</TableCell>

                      <TableCell>
                        <IconButton onClick={(e) => handleClick(e, list)}>
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          className="action-list"
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                        >
                          <MenuItem
                            className="action-item"
                            onClick={() => PreviewDataPointCalculation()}
                          >
                            {action.DPCALCULATION}
                          </MenuItem>
                          <MenuItem
                            className="action-item"
                            onClick={showPreviewDetails}
                          >
                            Preview
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )} */}
        {openDialog && (
          <Dialog
            fullScreen
            open={openDialog}
            onClose={handleDialogClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            closeAfterTransition
          >
            <ExcelOutput
              dialogData={dialogData}
              handleDialogClose={handleDialogClose}
            />
          </Dialog>
        )}
      </Box>
    </Box>
  );
};
export default Tables;
